import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextLabel from '../textLabel';
import CollapseArrow from './collapseArrow.svg.js';
import classNames from 'classnames';

var collapseLabel = /*#__PURE__*/function (_React$Component) {
  _inherits(collapseLabel, _React$Component);

  var _super = _createSuper(collapseLabel);

  function collapseLabel(props) {
    var _this;

    _classCallCheck(this, collapseLabel);

    _this = _super.call(this, props);
    _this.state = {
      isOpen: false,
      childHasHover: false
    };

    _this.onToggle = function () {
      if (!_this.props.disabled) {
        if (_this.props.customToggle) {
          _this.props.customToggle();

          _this.callOnToggleIfNeeded(!_this.props.isOpen);
        } else {
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              isOpen: !prevState.isOpen
            });
          }, function () {
            return _this.callOnToggleIfNeeded(_this.state.isOpen);
          });
        }
      }
    };

    _this.callOnToggleIfNeeded = function (isOpen) {
      if (_this.props.onToggle) {
        _this.props.onToggle(isOpen);
      }
    };

    _this.isChildHover = function () {
      return _this.state.childHasHover;
    };

    _this.handleOnMouseEnter = function () {
      return !_this.state.childHasHover && _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        childHasHover: true
      }));
    };

    _this.handleOnMouseLeave = function () {
      return _this.state.childHasHover && _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        childHasHover: false
      }));
    };

    _this.getIconState = function () {
      return _this.isOpen() ? 'open' : 'closed';
    };

    _this.isOpen = function () {
      return _this.props.customToggle ? _this.props.isOpen : _this.state.isOpen;
    };

    return _this;
  }

  _createClass(collapseLabel, [{
    key: "render",
    value: function render() {
      var suffixArray = this.props.suffix && (Array.isArray(this.props.suffix) ? this.props.suffix : [this.props.suffix]);
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapse-label-root",
        "data-hook": this.props.dataHook,
        className: classNames(this.props.getClassName('control-collapse-label'), this.props.disabled ? 'disabled' : '', this.isChildHover() ? 'child-has-hover' : '')
      }, /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapse-label-switch",
        className: classNames('collapse-label-switch', "skin-".concat(this.props.skin)),
        onClick: this.onToggle,
        "aria-checked": this.isOpen()
      }, /*#__PURE__*/React.createElement(TextLabel, {
        className: "collapse-text-label",
        automationId: "collapse-text-label",
        value: this.props.translateIfNeeded(this.props.label),
        type: "T15",
        disabled: this.props.disabled,
        shouldTranslate: this.props.shouldTranslate
      }), this.props.suffix && /*#__PURE__*/React.createElement("div", {
        className: classNames('suffix-wrapper', {
          'show-suffix': this.props.alwaysShowSuffix
        }),
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, suffixArray.map(function (suffix, i) {
        return /*#__PURE__*/React.createElement("div", {
          key: i,
          className: "suffix-item"
        }, suffix);
      })), /*#__PURE__*/React.createElement("div", {
        "data-aid": "switch-open",
        className: 'switch-open ' + this.getIconState()
      }, /*#__PURE__*/React.createElement(CollapseArrow, null))), this.isOpen() ? /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapsed-content-container",
        className: "collapsed-content-container",
        key: "collapsed-content-container",
        onMouseEnter: this.handleOnMouseEnter,
        onMouseLeave: this.handleOnMouseLeave
      }, this.props.children) : null);
    }
  }]);

  return collapseLabel;
}(React.Component);

collapseLabel.displayName = displayNames.COLLAPSE_LABEL;
collapseLabel.propTypes = {
  /** Label text to display */
  label: PropTypes.string.isRequired,

  /** Callback after toggle */
  onToggle: PropTypes.func,

  /** Callback function to be used in controlled mode */
  customToggle: PropTypes.func,

  /** Disables toggling */
  disabled: PropTypes.bool,

  /** Controlled state of collapse (only with `customToggle`) */
  isOpen: PropTypes.bool,

  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Title suffix node, usually used for info icon, context menu or similar actions */
  suffix: PropTypes.node,

  /** force suffix to always be visible */
  alwaysShowSuffix: PropTypes.bool,

  /** changing the look of the component  */
  skin: PropTypes.oneOf(['item', 'section'])
};
collapseLabel.defaultProps = {
  disabled: false,
  alwaysShowSuffix: false,
  skin: 'item'
};
export default compose(collapseLabel);